import Link from './Link'

export class SiteInfo {
	id: string
	title: string
	summary: string
	description?: string
	icon?: string
	links?: Link[]

	constructor(siteInfo: SiteInfo) {
		this.id = siteInfo.id
		this.title = siteInfo.title
		this.summary = siteInfo.summary
		this.description = siteInfo.description
		this.icon = siteInfo.icon
		this.links = siteInfo.links
	}
}

export type SiteInfo2 = {
	id: string
	title: string
	type?: SITE_INFO_TYPE
	summary?: string
	description?: string
	icon?: string
	links?: Link[]
}

export enum SITE_INFO_TYPE {
	DOCUMENTATION = 'documentation',
	MONEY = 'money',
	GASTRONOMY = 'gastronomy',
	TRANSPORT = 'transport',
	CLIMATE = 'climate',
	HEALTH_AND_SAFETY = 'healthAndSafety',
	CONNECTIVITY = 'connectivity',
	CULTURE = 'culture',
	SOUVENIRS = 'souvenirs',
}
